import leaflet from "leaflet";
import React from "react";
import * as L from "react-leaflet";

export class LeafletPolyline extends React.PureComponent {
  constructor(props) {
    super(props);
    this._extraPaddingSvgRenderer = leaflet.svg({ padding: 1 });
  }

  render() {
    const { color, weight, positions } = this.props;

    return <L.Polyline positions={positions} color={color} weight={weight} renderer={this._extraPaddingSvgRenderer} />;
  }
}
